"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _space = _interopRequireDefault(require("../../styles/space"));

var navigationDefaults = {
  subNavItemColor: 'greydark',
  subNavItemColorHeader: 'white',
  subNavItemColorHeaderExpanded: 'white',
  subNavItemColorHoverHeader: 'white',
  subNavItemColorLegacyHeader: 'greydark',
  subNavItemColorHoverLegacyHeader: 'greydark',
  subNavItemColorFooter: 'greydark',
  subNavItemColorHoverFooter: 'greydark',
  navItemTextColorHeaderMobile: 'white',
  navItemTextColorHeaderExpandedMobile: 'white',
  navItemTextColorHeaderDesktop: 'white',
  navItemTextColorLegacyHeader: 'greydark',
  navItemRemoveTextHoverColorLegacyHeader: 'offblack',
  navItemTextColorFooter: 'greydark',
  navItemRemoveTextHoverColorFooter: 'offblack',
  navItemIconColorLegacyHeader: 'greydark',
  navItemIconColorHeader: 'white',
  navItemIconColorFooter: 'greydark',
  navItemExpandedBgHeader: 'primary',
  navItemBgFooter: 'offwhite',
  navItemBgLegacyHeader: 'offwhite',
  navItemTextTransform: 'uppercase',
  subNavItemContainerHomeBorder: '2px solid rgba(38,38,38, .4)',
  subNavItemTextHomeBorder: '1px solid',
  subNavItemTextHomeBorderColor: 'primary',
  subNavItemTextHomeExpandedBorderColor: 'white',
  navItemHeaderFontSize: 'initial',
  navItemDescriptionOpacity: '.6',
  expandedLinksWrapperBgLegacyHeader: 'white',
  expandedLinksWrapperBgFooter: 'white',
  utilityFooterTextSizeMobile: 'initial',
  utilityFooterLineHeightMobile: 'initial',
  utilityFooterNavLinkMarginMobile: "0 ".concat(_space.default.base),
  utilityFooterNavLinkMarginDesktop: "0 ".concat(_space.default.large, " 0 0"),
  navWrapperFlexDirectionMobile: 'row',
  navBreakpoint: 'medium',
  mainNavLinkH4Color: 'greydark',
  navListGrid: [12, null, null, 6, 3],
  // Primary Menu - Slider
  primaryNavItemTextColor: 'primary',
  primarySubNavItemContainerHomeBorder: '2px solid rgba(101,103,112, .23)',
  primarySubNavItemTextHomeBorderColor: '2px solid rgba(101,103,112, .23)'
};
var navigation = {
  horizon: _objectSpread({}, navigationDefaults),
  cannesLions: _objectSpread({}, navigationDefaults),
  lionsLive: _objectSpread({}, navigationDefaults),
  money2020: _objectSpread(_objectSpread({}, navigationDefaults), {}, {
    navBreakpoint: 'xlarge',
    navItemTextColorHeaderDesktop: 'greydark',
    subNavItemTextHomeExpandedBorderColor: 'greydark',
    navListGrid: '12',
    navWrapperFlexDirectionMobile: 'column',
    utilityFooterNavLinkMarginMobile: "0 0 ".concat(_space.default.small),
    navItemTextColorFooter: 'white',
    navItemRemoveTextHoverColorFooter: 'white',
    navItemBgFooter: 'black',
    navItemIconColorFooter: 'white',
    expandedLinksWrapperBgFooter: 'black',
    subNavItemColorFooter: 'white',
    subNavItemColorHoverFooter: 'white'
  }),
  ascential: _objectSpread({}, navigationDefaults),
  dcl: _objectSpread(_objectSpread({}, navigationDefaults), {}, {
    navItemTextColorHeaderExpandedMobile: 'black',
    subNavItemColorHoverHeader: 'primary',
    navItemTextTransform: 'none'
  }),
  lionsCreativity: _objectSpread(_objectSpread({}, navigationDefaults), {}, {
    subNavItemColorHeader: 'primary',
    navItemHeaderFontSize: '2.7rem',
    navItemDescriptionOpacity: '1',
    subNavItemContainerHomeBorder: '2px solid rgba(255,255,255, .4)',
    subNavItemColorLegacyHeader: 'white',
    subNavItemColorHoverLegacyHeader: 'white',
    subNavItemColorFooter: 'white',
    subNavItemColorHoverFooter: 'white',
    navItemTextColorLegacyHeader: 'white',
    navItemRemoveTextHoverColorLegacyHeader: 'white',
    navItemTextColorFooter: 'white',
    navItemTextColorHeaderExpandedMobile: 'primary',
    subNavItemColorHoverHeader: 'primary',
    navItemRemoveTextHoverColorFooter: 'white',
    expandedLinksWrapperBgLegacyHeader: 'primary',
    expandedLinksWrapperBgFooter: 'primary',
    navItemBgLegacyHeader: 'primary',
    navItemBgFooter: 'primary',
    navItemIconColorFooter: 'white',
    utilityFooterTextSizeMobile: '1.4rem',
    utilityFooterLineHeightMobile: 'initial',
    utilityFooterNavLinkMarginMobile: "0 0 ".concat(_space.default.small),
    navWrapperFlexDirectionMobile: ' column',
    mainNavLinkH4Color: 'white',
    navItemIconColorLegacyHeader: 'white'
  })
};
var _default = navigation;
exports.default = _default;